import * as React from 'react';
// @ts-ignore
import { RadioButton as RB } from 'react-radio-buttons';
import styled from 'styled-components';
import { ThemeInterface } from '../../theme/ThemeInterface';

const Wrapper = styled.div`
  > div {
    background-color: #e5e5e5 !important;
    border-radius: 5px !important;
    border: 0 !important;

    & > div > div {
      color: ${(props: ThemeInterface) => props.theme.colors.textDefault};
      padding-right: 5px;
    }
  }
`;

const RadioButton: React.FC<any> = props => {
  return (
    <Wrapper>
      <RB {...props} />
    </Wrapper>
  );
};

export default RadioButton;
